import { Divider, Container, styled } from "@mui/material";
import { JSX } from "react";

import type { Theme } from "@mui/material/styles";

export const Footer = ({
  privacyPolicyUrl,
}: {
  privacyPolicyUrl: string;
}): JSX.Element => (
  <>
    <Divider />
    <StyledFooter>
      <a href={privacyPolicyUrl} target="_blank" rel="noopener noreferrer">
        Privacy Policy
      </a>
    </StyledFooter>
  </>
);

const StyledFooter = styled(Container)(({ theme }: { theme: Theme }) => ({
  marginTop: "auto",
  width: "100%",
  padding: "0.5rem",
  fontSize: "0.75rem",
  a: {
    color: (theme.vars ?? theme).palette.text.secondary,
    fontFamily: theme.typography.fontFamily,
    fontWeight: "bold",
  },
  "> div": {
    padding: "0.75rem 4.375rem",
  },
})) as unknown as typeof Container;
